/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GaitEnum } from '../models/GaitEnum';
import { HttpFile } from '../http/http';

export class TrackingPointCorrectionRequest {
    'points': Array<number>;
    'gait': GaitEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "points",
            "baseName": "points",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "gait",
            "baseName": "gait",
            "type": "GaitEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return TrackingPointCorrectionRequest.attributeTypeMap;
    }

    public constructor() {
    }
}



